/**
 * Reducers are the pure functions (no side effects!) that update the store. Each reducer updates it's part of the (single) store.
 * Each reducer contains properties and exposes a pure function that will update the relevant part of the store.
 * Combines all the reducers so they can be exposed as one data structure.
 *
 */
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import errors from './errors'
import user from './user'
import flowModel from './flow-model'
import { ActionTypes as types } from '../constants'
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

const appReducer = combineReducers({
  router: connectRouter(history),
  errors,
  user,
  flowModel,
})

const rootReducer = (state, action) => {
  if (action.type === types.RESET_TO_INITIAL) {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
